import React from "react";
import "../../css/toastView.css";
import Heading from "../../components/Heading";
import ContentPage from "../../components/content-page";
import Meta from "../../components/meta";
import PropTypes from "prop-types";
import ReactPixel from "react-facebook-pixel";
import Link from "gatsby-link";
import Modal from "../../components/Modal";
import Slider from "react-slick";
import "../../components/slick.css";
import "../../components/slick-theme.css";
import LinkedInTag from "react-linkedin-insight";

 
let duration = 400;
 

const I1 = "https://www.winpeforum.com/assets/elements/ama22sep1.jpeg";
const I2 = "https://www.winpeforum.com/assets/elements/ama22sep2.jpeg";
const I3 = "https://www.winpeforum.com/assets/elements/ama22sep3.jpeg";
 


const II1 = "https://www.winpeforum.com/download.php?file=assets/elements/ama22sep1.jpeg";
const II2 = "https://www.winpeforum.com/download.php?file=assets/elements/ama22sep2.jpeg";
const II3 = "https://www.winpeforum.com/download.php?file=assets/elements/ama22sep3.jpeg";
 

const TeamModal = ({ activeItem, show, onHide }) => {
  return (
    <Modal
      direction=""
      className="teamdetails__wrapper"
      show={show}
      onHide={onHide}
    >
      <Modal.Header>
        <div className="head_section">
          <span className="item_name">{activeItem.name}</span>
          <div
            className="item_des"
            dangerouslySetInnerHTML={{ __html: activeItem.post }}
          ></div>
        </div>
        <span className="cross pull-right">
          <i onClick={onHide} className="fa fa-times" />
        </span>
      </Modal.Header>
      <Modal.Body>
        <div className="item__desc">
          <div dangerouslySetInnerHTML={{ __html: activeItem.desc }}></div>
        </div>
      </Modal.Body>
      <Modal.Footer />
    </Modal>
  );
};

TeamModal.propTypes = {
  activeItem: PropTypes.object,
  show: PropTypes.object,
  onHide: PropTypes.object,
};

export class SheShines extends React.Component {
  constructor(args) {
    super(args);
    this.state = {
      slidesToShow: 1,
      activeItem: {},
      isShow: false,
      defaultStyle: {
        transition: `opacity ${duration}ms ease-in-out`,
        opacity: 0,
      },
    };
 
    
    this.CollegiumsImages = [
      { id:23, ImgSrc: I1, ImgSrc1: II1,},   
      { id:27, ImgSrc: I2, ImgSrc1: II2,},  
        
      

        { id:62, ImgSrc: I3, ImgSrc1: II3,},    
        
      
    
    ];
  
  }
  componentDidMount() {
    this.updateWindowDimensions();
    window.addEventListener("resize", this.updateWindowDimensions);
    ReactPixel.init("2879175222167037");
    ReactPixel.track("ViewContent", location);
    LinkedInTag.init("2117884");
    LinkedInTag.track("2310748");
    setTimeout(() => {
      this.setState({
        defaultStyle: {
          transition: `opacity ${duration}ms ease-in-out`,
          opacity: 1,
        },
      });
    }, 500);
  }
  componentWillUnmount() {
    window.removeEventListener("resize", this.updateWindowDimensions);
  }

  updateWindowDimensions = () => {
    const { slidesToShow } = this.state;
    // // console.log("width", window.innerWidth)
    if (window.innerWidth <= 768 && window.innerWidth > 500) {
      if (slidesToShow !== 1) {
        this.setState({
          slidesToShow: 1,
        });
      }
    } else if (window.innerWidth <= 500) {
      if (slidesToShow !== 1) {
        this.setState({
          slidesToShow: 1,
        });
      }
    } else {
      if (slidesToShow !== 1) {
        this.setState({
          slidesToShow: 1,
        });
      }
    }
  };
  togglePopUp = (item) => {
    this.setState({
      isShow: !this.state.isShow,
      activeItem: item || {},
    });
  };
  render() {
    const { defaultStyle, isShow, slidesToShow } = this.state;
    const { location } = this.props;
    let settings = {
      dots: false,
      infinite: true,
      speed: 6000,
      autoplay: true,
      slidesToShow: slidesToShow,
      slidesToScroll: slidesToShow,
      autoplaySpeed: 7000,
      arrows: true,
    };
    console.log("render", this.render1, slidesToShow);
    this.render1 = this.render1 + 1;
    return (
      <ContentPage>
        <Meta
          title="Ask Me Anything with Ashley Menezes"
          image={"https://winpeforum.com/assets/elements/WinPE_Home_Page_link_image1.jpg"}
          description="The very first Ask Me Anything (AMA) event with ChrysCapital took place on September 22nd. This event was exclusively for women considering transitioning careers to Private Equity and Venture Capital (PEVC)."
          location={location}
        />
        <div className="section__content" style={defaultStyle}>
          <div className="toastshine_wrapper">
            <div className="back_event">
              <Link to="/events/">
                <i className="fa fa-arrow-left"> Back to Events</i>
              </Link>
            </div>
            <div className="toastshine_section">
              <div className="m_heading">Ask Me Anything with Ashley Menezes </div>
              <div className="r_btm"></div>
               
 
              <div className="date_heading">
                <div className="date_heading">
                  <span>22 SEPTEMBER 2022</span>
                   
                </div>
              </div>
              {/* <div className="College_page">
                <span>
                  <img
                    src="https://px.ads.linkedin.com/collect/?pid=2117884&conversionId=2310748&fmt=gif"
                    alt="events link"
                  />
                  <a
                    href="https://docs.google.com/forms/d/e/1FAIpQLSfTEePX88AjH_IGhVYAQtB5B3oqLlK4qQe8lsA-qnijKuiydQ/viewform"
                    target="_blank"
                  >
                    Register Now
                  </a>
                </span>
              </div> */}
              <div className="top_text">
              The very first Ask Me Anything (AMA) event with ChrysCapital took place on September 22nd. This event was exclusively for women considering transitioning careers to Private Equity and Venture Capital (PEVC). In the session, important topics were discussed such as how to successfully switch careers, understanding PEVC career paths, essential skills, the differences between PEVC and traditional fields, upcoming industries, and what to expect in job interviews when making a career change.<br/><br/>

The session started by giving an overview of the PEVC sector, explaining the different teams in these firms, such as investing, operations, strategy, and functions. The crucial skills like analytical thinking, finding deals (as you move up in your career), effective communication, and networking were also talked about. The importance of writing a good resume and being honest during interviews was emphasized. Additionally, the significance of a hunger for learning, curiosity, and having a logical mindset as key attributes were highlighted.<br/><br/>

AMAs will be organized each quarter across Delhi NCR and Mumbai as small group discussions focused on detailed interactions.
              </div>
              <br />

           
 
              <div className="container">
                    <div>
                      <Heading title="Gallery" />
                    </div>
                    <div className="row">
                      {this.CollegiumsImages.map((item, j) => {
                        return (
                          <div className="col-lg-4 col-md-4 col-sm-6 col-xs-12" style={{padding: '8px'}}>
                            <div className="img_card">
                            <img style={{width:'100%', height:'240px', objectFit:'cover'}} src={item.ImgSrc} alt="Winpe" />
                            <a href={item.ImgSrc1} > <i style={{color:'white', position:'absolute', left:'330px', top:'20px'}} class="fa fa-2x  fa-download "></i></a> 
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                 <br/>
  <br/> 
    
<br/><br/>
             

            </div>
            <TeamModal
              show={isShow}
              onHide={this.togglePopUp}
              activeItem={this.state.activeItem}
            />
          </div>
        </div>
      </ContentPage>
    );
  }
}

SheShines.propTypes = {
  location: PropTypes.object,
};

export default SheShines;



// WEBPACK FOOTER //
// ./src/pages/AskMeAnything/index.js